import { withRouter } from 'react-router-dom';
import withWidth from '@material-ui/core/withWidth';
import Toolbar from '@material-ui/core/Toolbar';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { UserConsumer } from './providers/UserProvider';
import MaintenanceWarning from './MaintenanceWarning';
import Release from './Release';
import { globalStyles as styles } from './style/gstheme';
import { withStyles } from '@material-ui/core/styles';
import UserInfo from './users/UserInfo';


class StandardAppBar extends Component {

  goHome = () => {
    if (this.props.onGoHome) {
      this.props.onGoHome();
    }
    this.props.history.push("/");
  }

  render() {

    const { displaySubscription, width, classes } = this.props;
    const title = window.Graphologi.title;

    return (
      <UserConsumer>
        {({ user, activeSubscriptionName, logOut, idleTime, logOutDelay, hideMaintenance, hideRelease }) => {
          const isAdmin = user.systemAdmin || user.superAdmin;
          return <React.Fragment>
            <UserInfo logOut={logOut} logOutDelay={logOutDelay} user={user} currentDelay={idleTime / 60000} />
            <div style={{ backgroundColor: '#13294B', height: '64px' }}>
              <Toolbar>
                <span onClick={this.goHome} className={classes.appIcon}>
                  {width === "xs" ?
                    <img data-test="home" src="/images/icon-reversed.png" alt="Logo" style={{ width: 40, marginLeft: 40, marginTop: 8, zIndex: 1000 }} />
                    :
                    <img data-test="home" src="/images/logo-reversed.png" alt="Logo" style={{ width: 150, marginLeft: 40, zIndex: 1000 }} />
                  }
                </span>
                {width !== "xs" && width !== "sm" && title &&
                  <div style={{ position: 'absolute', top: 42, fontSize: 12, left: 110, color: 'white' }} >
                    <span data-test="org-title" style={{ display: 'inline-block', margin: '0 auto', fontWeight: 300, letterSpacing: '1px' }}>{title}</span>
                  </div>
                }
                {width !== "xs" && width !== "sm" && displaySubscription && !isAdmin &&
                  <div style={{ position: 'absolute', top: 37, fontSize: 14, left: 0, textAlign: 'center', width: '100%', color: 'white' }} >
                    <span data-test="active-subscription-title" style={{ display: 'inline-block', margin: '0 auto', fontWeight: 300, letterSpacing: '1px' }}>{activeSubscriptionName}</span>
                  </div>
                }
              </Toolbar>
            </div>
            {user.adminWindow && user.adminWindow.startTime && !hideMaintenance ?
              <MaintenanceWarning />
              :
              !hideRelease && user && user.username &&
              <Release />
            }
          </React.Fragment>;
        }}
      </UserConsumer>
    );
  }
}

StandardAppBar.defaultProps = {
  displaySubscription: true
};

StandardAppBar.propTypes = {
  onGoHome: PropTypes.func,
  title: PropTypes.string,
  history: PropTypes.object,
  width: PropTypes.string,
  displaySubscription: PropTypes.bool,
  classes: PropTypes.object
};

export default withWidth()(withStyles(styles)(withRouter(StandardAppBar)));
